<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1fq2pb/images/cover.jpg?1731429761904" alt="This image is the cover for the book Sorcerer's Apprentice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sorcerer's Apprentice
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A diverse new anthology that traces the meaning and magic of the sorcerer's apprentice tale throughout history</b><br/><br/>"The Sorcerer's Apprentice" might conjure up images of Mickey Mouse from the Disney film <i>Fantasia</i>, or of Harry Potter. As this anthology reveals, however, "sorcerer's apprentice" tales—in which a young person rebels against, or complies with, an authority who holds the keys to magical powers—have been told through the centuries, in many languages and cultures, from classical times to today. This unique and beautifully illustrated book brings together more than fifty sorcerer's apprentice stories by a plethora of writers, including Ovid, Sir Walter Scott, and the Brothers Grimm. From Goethe's "The Pupil in Magic" to A. K. Ramanujan's "The Guru and His Disciple," this expansive collection presents variations of a classic passed down through countries and eras.<br/><br/>Readers enter worlds where household objects are brought to life and shape-shifting occurs from human to animal and back again. We meet two types of apprentice: "The Humiliated Apprentice," a foolish bumbler who wields magic ineffectively and promotes obedience to authority; and "The Rebellious Apprentice" who, through ambition and transformative skills, promotes empowerment and self-awareness. In an extensive introduction, esteemed fairy-tale scholar Jack Zipes discusses the significance and meaning of the apprentice stories, the contradictions in popular retellings, and the importance of magic as a tool of resistance against figures who abuse their authority. Twenty specially commissioned black-and-white illustrations by noted artist Natalie Frank bring the stories to visual life.<br/><br/><i>The Sorcerer's Apprentice</i> enlightens and entertains readers with enduring, spellbinding tales of sorcery that have been with us through the ages.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Zipes, Natalie Frank
      </h2>
      
      <p class="authorDescription body article"><B>Jack Zipes</B> is the editor and translator of <I>The Original Folk and Fairy Tales of the Brothers Grimm</I> (Princeton) and the editor of <I>The Great Fairy Tale Tradition</I> (Norton). He is professor emeritus of German and comparative literature at the University of Minnesota. <B>Natalie Frank</B> is an American artist currently living and working in New York City. Her work is held in multiple museum collections, including the Whitney Museum of American Art and the Brooklyn Museum.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Princeton University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ffb49674